import api from './api';

export default {
  // Occupations
  async getOccupations(params = {}) {
    const { data } = await api.get('/admin/esco/occupations', { params });
    return data;
  },

  async getOccupation(id, params = {}) {
    const { data } = await api.get(`/admin/esco/occupations/${id}`, { params });
    return data;
  },

  async updateOccupation(id, payload) {
    const { data } = await api.patch(`/admin/esco/occupations/${id}`, payload);
    return data;
  },

  // Occupation ↔ Skills
  async addOccupationSkill(occupationId, payload) {
    const { data } = await api.post(`/admin/esco/occupations/${occupationId}/skills`, payload);
    return data;
  },

  async updateOccupationSkill(occupationId, skillId, payload) {
    const { data } = await api.patch(`/admin/esco/occupations/${occupationId}/skills/${skillId}`, payload);
    return data;
  },

  async removeOccupationSkill(occupationId, skillId) {
    const { data } = await api.delete(`/admin/esco/occupations/${occupationId}/skills/${skillId}`);
    return data;
  },

  // Occupation ↔ Sectors
  async addOccupationSector(occupationId, payload) {
    const { data } = await api.post(`/admin/esco/occupations/${occupationId}/sectors`, payload);
    return data;
  },

  async updateOccupationSector(occupationId, sectorId, payload) {
    const { data } = await api.patch(`/admin/esco/occupations/${occupationId}/sectors/${sectorId}`, payload);
    return data;
  },

  async removeOccupationSector(occupationId, sectorId) {
    const { data } = await api.delete(`/admin/esco/occupations/${occupationId}/sectors/${sectorId}`);
    return data;
  },

  // Skills
  async getSkills(params = {}) {
    const { data } = await api.get('/admin/esco/skills', { params });
    return data;
  },

  async getSkill(id) {
    const { data } = await api.get(`/admin/esco/skills/${id}`);
    return data;
  },

  async updateSkill(id, payload) {
    const { data } = await api.patch(`/admin/esco/skills/${id}`, payload);
    return data;
  },

  async mergeSkills(payload) {
    const { data } = await api.post('/admin/esco/skills/merge', payload);
    return data;
  },

  // Skill Groups
  async getSkillGroupStats() {
    const { data } = await api.get('/admin/esco/skill-groups/stats');
    return data;
  },

  async getSkillGroupsList() {
    const { data } = await api.get('/admin/esco/skill-groups/list')
    return data
  },
  async getGroupSkills(group, params = {}) {
    const { data } = await api.get(`/admin/esco/skill-groups/${encodeURIComponent(group)}/skills`, { params })
    return data
  },
  async updateSkillGroup(group, payload) {
    const { data } = await api.patch(`/admin/esco/skill-groups/${encodeURIComponent(group)}`, payload)
    return data
  },
  async archiveSkillGroup(group) {
    const { data } = await api.post('/admin/esco/skill-groups/archive', { group });
    return data;
  },
  async getSkillGroupCategories() {
    const { data } = await api.get('/admin/esco/skill-group-categories')
    return data
  },

  // Sector Stats
  async getSectorStats() {
    const { data } = await api.get('/admin/esco/sector-stats');
    return data;
  },

  // Reference data
  async getSectors() {
    const { data } = await api.get('/reference/sectors');
    return data;
  },

  async getSectorGroups() {
    const { data } = await api.get('/reference/sector-groups');
    return data;
  },
};
